import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getPlansTemplates } from '../services/plans';
import usePagination from './usePagination';

export const usePlansTemplates = () => {
    const {
        paginationModel,
        setPaginationModel,
        rowsPerPageOptions,
        count,
        currentToken,
        resolveHeader
    } = usePagination();

    const fetchPlans = async ({ queryKey }) => {
        const [, { paginationModel }] = queryKey;
        return getPlansTemplates(
            paginationModel.pageSize,
            currentToken(paginationModel.page)
        );
    };

    const { data, isPending, isError } = useQuery({
        queryKey: ['plans-templates', { paginationModel }],
        queryFn: fetchPlans,
        keepPreviousData: true
    });

    useEffect(() => {
        if (data) {
            resolveHeader(data.headers, paginationModel.page);
        }
    }, [data]);

    return {
        data: data?.data || [],
        isLoading: isPending,
        error: isError,
        count,
        rowsPerPageOptions,
        paginationModel,
        setPaginationModel
    };
};